import {HookClass} from "@dvrt/graphql-widgets";
import {MutableRefObject, useEffect, useRef, useState} from "react";
import {createInitialData} from "@/components/gateway/routing/initialData";
import {
    PrivateRoutingLazyQueryHookResult,
    PrivateRoutingQuery,
    usePrivateRoutingLazyQuery,
} from "@/components/gateway/routing/queries.generated";

export type Data = {
    gatewayRoutings: PrivateRoutingQuery;
};

const initialData: Data = {
    gatewayRoutings: null,
};

export default class DataSource extends HookClass {
    protected domainId!: number;
    protected setLoaded!: (value: boolean) => void;

    public data!: MutableRefObject<Data>;
    public loaded!: boolean;

    private query!: PrivateRoutingLazyQueryHookResult[0];

    useHooks(domainId: number) {
        [this.loaded, this.setLoaded] = useState<boolean>(false);
        this.domainId = domainId;
        this.data = useRef<Data>(initialData);
        [this.query] = usePrivateRoutingLazyQuery({
            variables: {domainId},
            fetchPolicy: "no-cache",
        });

        useEffect(() => {
            this.fetch();
        }, []);
    }

    get initialData() {
        return createInitialData(this.domainId, this.data.current.gatewayRoutings);
    }

    async fetch() {
        this.setLoaded(false);

        const {data} = await this.query();

        this.data.current.gatewayRoutings = data;

        this.setLoaded(true);
    }
}
